import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Card,
    CardContent,
    Typography,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Skeleton,
    Button
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link as RouterLink } from "react-router-dom";

const TurmobWidget = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMevzuat = async () => {
            try {
                const originUrl = "https://www.turmob.org.tr/Mevzuat";
                const proxyUrl = `https://cors-proxy-suhas-projects-5922cb4f.vercel.app/?target=${encodeURIComponent(originUrl)}`;
                const response = await axios.get(proxyUrl, { headers: { "Content-Type": "text/html" } });

                const parser = new DOMParser();
                const doc = parser.parseFromString(response.data, "text/html");

                const mevzuatList = [];
                doc.querySelectorAll(".layout-container a").forEach((element, index) => {
                    //if (index >= 5) return; // Sadece ilk 5 duyuruyu al
                    const title = element.innerText.trim();
                    const baseUrl = element.href
                    const uri = new URL(baseUrl).pathname;
                    const url = `https://www.turmob.org.tr${uri}`;
                    mevzuatList.push({ title, url });
                });
                setAnnouncements(mevzuatList);
                setLoading(false);
            } catch (error) {
                console.error("Mevzuat duyuruları yüklenirken hata oluştu:", error);
                setLoading(false);
            }
        };

        fetchMevzuat();
    }, []);

    const mobileAnnouncements = announcements.slice(0, 3);
    const desktopAnnouncements = announcements.slice(0, 5);

    const renderAnnouncements = (list) => (
        <Box sx={{ 
            maxHeight: 330,
            overflow: "auto",
            "&::-webkit-scrollbar": {
                width: "8px",
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#1976d2",
                borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#1565c0",
            },
            scrollbarWidth: "thin",
            scrollbarColor: "#1976d2 #f1f1f1",
        }}>
            <List dense sx={{ padding: 0 }}>
                {list.map((item, index) => (
                    <ListItem key={index} disableGutters sx={{ py: 0.5 }}>
                        <ListItemIcon>
                            <FiberManualRecordIcon sx={{ fontSize: 6, color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>
                            <a href={item.url} target="_blank" rel="noopener noreferrer"
                               style={{ textDecoration: "none", color: "#333", fontSize: "13px", lineHeight: "1.4" }}>
                                {item.title}
                            </a>
                        </ListItemText>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <Card sx={{ maxWidth: 380, height: { md: 450 }, borderRadius: 2, boxShadow: 2, border: "1px solid #ddd", p: 1 }}>
            <CardContent sx={{ p: 2 }}>
                {/* Başlık */}
                <Box display="flex" alignItems="center" mb={1}>
                    <img src="/turmob-logo.png" alt="TÜRMOB Logo" width={30} height={30} />
                    <Typography variant="subtitle1" color="primary" fontWeight="bold" ml={1}>
                        TÜRMOB Duyuruları
                    </Typography>
                </Box>

                {loading ? (
                    <Box>
                        <Skeleton variant="text" width="80%" />
                        <Skeleton variant="text" width="90%" />
                        <Skeleton variant="text" width="75%" />
                        <Skeleton variant="text" width="85%" />
                    </Box>
                ) : (
                    <Box>
                        <Divider sx={{ my: 1 }} />

                        {/* Mobilde 3 duyuruyu göster */}
                        <Box sx={{ display: { xs: "block", sm: "none" } }}>
                            {renderAnnouncements(mobileAnnouncements)}
                        </Box>

                        {/* Büyük ekranlarda 5 duyuruyu göster */}
                        <Box sx={{ display: { xs: "none", sm: "block" } }}>
                            {renderAnnouncements(desktopAnnouncements)}
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button 
                                component={RouterLink} 
                                to="/haberler/turmob" 
                                size="small" 
                                color="primary" 
                                endIcon={<ArrowForwardIcon />}
                            >
                                Daha Fazla
                            </Button>
                        </Box>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default TurmobWidget;
